import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
    resources: {
        en: {
        translation: {
        cozy: "Cozy",
        modern: "Modern",
        spacious: "Spacious",
        luxurious: "Luxurious",
        affordable: "Affordable",
        office: "Office",
        workspace: "Workspace",
        conference_room: "Conference Room",
        desk: "Desk",
        hostGuests: "Host Guests",
        addListing: "Add Listing",
        aboutUs: "About US",
        signIn: "Sign In",
        signUp: "Sign Up",
        signOut: "Sign Out",
        profile: "Profile",
        pendingItems: "You have pending reservations actions, please",
        clickHere: "Click Here",
        whyRoom2w: "Why Room2w",
        earnWithUs: "Earn with Us",
        filters: "Filters",
        filterOptions: "Filter Options",
        location: "Location",
        price: "Price",
        rating: "Rating",
        occupants: "Occupants",
        applyFilters: "Apply Filters",
        noListings: "No listings found matching the criteria.",
        loadMore: "Load More",
        hour: "hour",
        stayWith: "Stay with",
        memberSince: "Member since",
        reviews: "Reviews",
        noReviewsAvailable: "No Reviews Available",
        occupants: "Occupants",
        occupant: "Occupant",
        includeOvernight: "Include Overnight",
        checkinDate: "Check-in Date",
        selectcheckinDate: "Select Check-in Date",
        checkinTime: "Check-in Time",
        selectCheckinTime: "Select Check-in Time",
        checkoutDate: "Check-out Date",
        selectCheckoutDate: "Select Check-out Date",
        checkoutTime: "Check-out Time",
        selectCheckoutTime: "Select Check-out Time",
        startDate: "Start Date",
        selectDates: "Select Dates",
        endDate: "End Date",
        startTime: "Start Time",
        selectDailyTime: "Select Daily Time",
        endTime: "End Time",
        includeSaturdays: "Include Saturdays",
        includeSundays: "Include Sundays",
        reserve: "Reserve",
        totalHours: "Total Hours",
        hours: "hours",
        cost: "Cost",
        excluding: "Excluding",
        totalCost: "Total Cost",
        }
        },
        fi: {
        translation: {
        cozy: "Kodikas",
        modern: "Moderni",
        spacious: "Tilava",
        luxurious: "Ylellinen",
        affordable: "Edullinen",
        office: "Toimisto",
        workspace: "Työtila",
        conference_room: "Kokoushuone",
        desk: "Pöytä",
        hostGuests: "Isännöi vieraita",
        addListing: "Lisää listaus",
        aboutUs: "Tietoja meistä",
        signIn: "Kirjaudu sisään",
        signUp: "rekisteröidy",
        signOut: "Kirjaudu ulos",
        profile: "Profiili",
        pendingItems: "Sinulla on odottavia varaustoimintoja, kiitos",
        clickHere: "Napsauta tästä",
        whyRoom2w: "Miksi Room2W",
        earnWithUs: "Ansaitse kanssamme",
        filters: "Suodattimet",
        filterOptions: "Suodatusvaihtoehdot",
        location: "Sijainti",
        price: "Hinta",
        rating: "Arvostelu",
        occupants: "Asukkaat",
        applyFilters: "Käytä suodattimia",
        noListings: "Hakuehtoja vastaavia ilmoituksia ei löytynyt.",
        loadMore: "Lataa lisää",
        hour: "tunnin",
        stayWith: "Pysy kanssa",
        memberSince: "Jäsen vuodesta",
        reviews: "Arvostelut",
        noReviewsAvailable: "Arvosteluja ei ole saatavilla",
        occupants: "asukkaat",
        occupant: "asukas",
        includeOvernight: "Sisällytä Yöpyminen",
        checkinDate: "Sisäänkirjautumispäivä",
        selectcheckinDate: "Valitse sisäänkirjautumispäivä",
        checkinTime: "Sisäänkirjautumisaika",
        selectCheckinTime: "Valitse sisäänkirjautumisaika",
        checkoutDate: "Uloskirjautumispäivä",
        selectCheckoutDate: "Valitse Uloskirjautumispäivä",
        checkoutTime: "Uloskirjautumisaika",
        selectCheckoutTime: "Valitse Uloskirjautumisaika",
        startDate: "Aloituspäivämäärä",
        selectDates: "Valitse Päivämäärät",
        endDate: "Päättymispäivämäärä",
        startTime: "Aloitusaika",
        selectDailyTime: "Valitse Päivittäinen aika",
        endTime: "Päättymisaika",
        includeSaturdays: "Sisältää lauantait",
        includeSundays: "Sisältää sunnuntait",
        reserve: "Varata",
        totalHours: "Tunteja yhteensä",
        hours: "Tuntia",
        cost: "Maksaa",
        excluding: "Lukuun ottamatta",
        totalCost: "Kokonaiskustannukset",
        }
    }
  },
  lng: "en", // Default language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false
  }
});

export default i18n;



